<!-- Upload Dialog -->
@if (showUploadDialog()) {
  <div class="modal fade show d-block" style="background-color: rgba(0,0,0,0.5)">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Upload Files</h5>
          <button type="button" class="btn-close" (click)="closeDialog()" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          @if (selectedFolderName()) {
            <p><strong>Upload to:</strong> {{ selectedFolderName() }}</p>
          }

          @if (selectedFiles().length > 0) {
            <div class="mb-3">
              <h6>Selected Files:</h6>
              <ul class="list-group">
                @for (file of selectedFiles(); track file.name) {
                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    {{ file.name }}
                    <span class="badge bg-secondary">{{ formatFileSize(file.size) }}</span>
                  </li>
                }
              </ul>
            </div>
          } @else {
            <p>No files selected</p>
          }

          @if (isUploading()) {
            <div class="progress mb-3">
              <div class="progress-bar" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                {{ uploadProgress() }}
              </div>
            </div>
          }
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDialog()" [disabled]="isUploading()">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" (click)="performUpload()" [disabled]="selectedFiles().length === 0 || isUploading()">
            @if (isUploading()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Uploading...
            } @else {
              Upload Files
            }
          </button>
        </div>
      </div>
    </div>
  </div>
}
